import React, { useEffect, useRef, useState } from 'react';
import axios from "axios";
import { useParams } from "react-router-dom";
import "./ApplyModal.css";
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;

function ApplyModal({ isOpen, onClose }) {
  const [schools, setSchools] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedSchool, setSelectedSchool] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const { school_slug } = useParams();
  const [alertState, setAlertState] = useState({
    show: false,
    title: "",
    message: "",
    type: "success"
  });

  useEffect(() => {
    const loadSchools = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          `${baseAPIUrl}admin/general_settings/get_schools/`,
          { withCredentials: true }
        );

        if (res.data.status === 1 && res.data.data) {
          const schoolList = res.data.data;
          setSchools(schoolList);

          // 🔥 If URL contains school_slug
          if (school_slug) {
            const matchedSchool = schoolList.find(
              (school) =>
                school.school_slug.toLowerCase() === school_slug.toLowerCase()
            );

            if (matchedSchool) {
              setSelectedSchool(matchedSchool.id);

              setFormData(prev => ({
                ...prev,
                school: matchedSchool.id
              }));

              fetchClasses(matchedSchool.id);
            }
          }
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    loadSchools();
  }, [school_slug]);

  const [classes, setClasses] = useState([]);
  const [selectedClass, setSelectedClass] = useState("");

  const fetchClasses = async (schoolId) => {
    if (!schoolId) {
      setClasses([]);
      return;
    }

    try {
      const res = await axios.get(
        `${baseAPIUrl}admin/general_settings/get_classes/${schoolId}`,
        { withCredentials: true }
      );

      if (res.data.status === 1) {
        setClasses(res.data.data || []);
      } else {
        setClasses([]);
      }

    } catch (error) {
      console.error(error);
      setClasses([]);
    }
  };

  const statesOfIndia = [
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chhattisgarh",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
    "Andaman and Nicobar Islands",
    "Chandigarh",
    "Dadra and Nagar Haveli and Daman and Diu",
    "Delhi",
    "Jammu and Kashmir",
    "Ladakh",
    "Lakshadweep",
    "Puducherry"
  ];

  const [formData, setFormData] = useState({
    parentName: "",
    studentName: "",
    email: "",
    mobile: "",
    school: "",
    className: "",
    state: "",
    cityName: "",
  });

  const [errors, setErrors] = useState({
    parentName: "",
    studentName: "",
    email: "",
    mobile: "",
    school: "",
    className: "",
    state: "",
    cityName: "",
  });

  const validateName = (name) => {
    const regex = /^[A-Za-z ]*$/;
    return regex.test(name);
  };

  const handleNameChange = (field, value) => {

    if (!validateName(value)) {
      return; // block invalid characters
    }

    setFormData(prev => ({
      ...prev,
      [field]: value
    }));

    // remove error if valid
    setErrors(prev => ({
      ...prev,
      [field]: ""
    }));
  };

  const [formValid, setFormValid] = useState(false);

  // Indian mobile validation
  const validateMobile = (number) => {
    const regex = /^[6-9]\d{9}$/;
    return regex.test(number);
  };

  // Email validation
  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };


  useEffect(() => {
    const isValid =
      formData.parentName.trim() !== "" &&
      formData.studentName.trim() !== "" &&
      validateEmail(formData.email) &&
      validateMobile(formData.mobile) &&
      formData.school !== "" &&
      formData.className !== "" &&
      formData.state !== "" &&
      formData.cityName !== "";
    setFormValid(isValid);
  }, [formData]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formValid) return;

    try {
      const res = await axios.post(
        `${baseAPIUrl}admin/general_settings/save_admission_enquiry`,
        {
          ...formData,
        }
      );

      // ✅ Check API status
      if (res.data.status === 1) {
        setAlertState({
          show: true,
          title: "Thank You!",
          message: res.data.success_message,
          type: "success"
        });

        // Reset form
        setFormData({
          parentName: "",
          studentName: "",
          email: "",
          mobile: "",
          school: "",
          className: "",
          state: "",
          cityName: "",
        });

        setSelectedSchool("");
        setSelectedClass("");
        setSelectedState("");
        setClasses([]);

      } else {
        setAlertState({
          show: true,
          title: "Submission Error",
          message: res.data.success_message || "Something went wrong",
          type: "error"
        });
      }

    } catch (error) {
      console.error(error);
      setAlertState({
        show: true,
        title: "Submission Failed",
        message: "Unable to submit your enquiry at this moment. Please check your connection and try again.",
        type: "error"
      });
    }
  };



  return (
    <>
      {isOpen && (
        <div className="modal-overlay" onClick={onClose}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              {/* Header Titles */}
                <div className="subtitle">ADMISSION ENQUIRY 2026-27<h1 className="title">Begin Your<br />Journey</h1></div>
                
              <button className="close-btn" onClick={onClose} aria-label="Close modal">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="form-section">
                
                
                

                {/* Student Name */}
                <div className="form-group">
                  <input
                    type="text"
                    placeholder="Enter Student Name *"
                    value={formData.studentName}
                    onChange={(e) => handleNameChange("studentName", e.target.value)}
                    className={errors.studentName ? "input-error" : ""}
                    required
                    autoComplete="name"
                  />
                  {errors.studentName && (
                    <small className="error-text">{errors.studentName}</small>
                  )}
                </div>

                {/* Email Address */}
                <div className="form-group">
                  <input
                    type="email"
                    value={formData.email}
                    onChange={(e) =>
                      setFormData({ ...formData, email: e.target.value })
                    }
                    placeholder="Enter Email Address *"
                    className={formData.email && !validateEmail(formData.email) ? "input-error" : ""}
                    required
                    autoComplete="email"
                  />
                  {formData.email && !validateEmail(formData.email) && (
                    <small className="error-text">
                      Enter valid email address
                    </small>
                  )}
                </div>

                {/* Contact Number (Mobile) */}
                <div className="form-group">
                  <div className={`mobile-input-wrapper ${formData.mobile && !validateMobile(formData.mobile) ? "input-error" : ""}`}>
                    <span>+91</span>
                    <input
                      type="tel"
                      maxLength="10"
                      value={formData.mobile}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, '');
                        setFormData({ ...formData, mobile: value });
                      }}
                      placeholder="Enter 10 digit Contact Number *"
                      required
                      autoComplete="tel"
                    />
                  </div>
                  {formData.mobile && !validateMobile(formData.mobile) && (
                    <small className="error-text">
                      Enter valid Indian mobile (Starts with 6-9 & 10 digits)
                    </small>
                  )}
                </div>

                {/* School & Class Row */}
                <div className="form-row">
                  <div className="form-col">
                    <div className="form-group" style={{ marginBottom: 0 }}>
                      <div className="input-icon-wrapper">
                        <select
                          value={selectedSchool}
                          onChange={(e) => {
                            const schoolId = e.target.value;
                            setSelectedSchool(schoolId);
                            setSelectedClass("");      // reset class
                            fetchClasses(schoolId);    // fetch classes

                            setFormData(prev => ({
                              ...prev,
                              school: schoolId,
                              className: ""
                            }));
                          }}
                          required
                          disabled={!!school_slug}
                        >
                          <option value="" disabled selected hidden>Select School *</option>
                          {schools.map((school) => (
                            <option key={school.id} value={school.id}>
                              {school.school_name}
                            </option>
                          ))}
                        </select>
                        <svg className="field-icon-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                          <polyline points="6 9 12 15 18 9"></polyline>
                        </svg>
                      </div>
                    </div>
                  </div>

                  <div className="form-col">
                    <div className="form-group" style={{ marginBottom: 0 }}>
                      <div className="input-icon-wrapper">
                        <select
                          value={selectedClass}
                          onChange={(e) => {
                            const classValue = e.target.value;
                            setSelectedClass(classValue);
                            setFormData(prev => ({
                              ...prev,
                              className: classValue
                            }));
                          }}
                          required
                          disabled={!selectedSchool}
                        >
                          <option value="" disabled selected hidden>
                            {selectedSchool ? "Select Class *" : "Select School First"}
                          </option>
                          {classes.map((cls) => (
                            <option key={cls.id} value={cls.class_name}>
                              {cls.class_name}
                            </option>
                          ))}
                        </select>
                        <svg className="field-icon-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                          <polyline points="6 9 12 15 18 9"></polyline>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>

                <div style={{ height: "28px" }}></div>

                
                

              </div>

              {/* Submit Button */}
              <div className="submit-container">
                <button type="submit" className="submit-btn" disabled={!formValid}>
                  <span>Submit Enquiry</span>
                  <svg className="btn-icon" viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                    <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"></path>
                  </svg>
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {alertState.show && (
        <div className="custom-alert-overlay">
          <div className="custom-alert-card">
            <div className={`custom-alert-icon ${alertState.type}`}>
              {alertState.type === 'success' ? (
                <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#28a745" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              ) : (
                <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#dc3545" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              )}
            </div>
            <h4 className="custom-alert-title">{alertState.title}</h4>
            <p className="custom-alert-message">{alertState.message}</p>
            <button 
              className="custom-alert-btn"
              onClick={() => {
                setAlertState(prev => ({ ...prev, show: false }));
                if (alertState.type === 'success') {
                  onClose();
                }
              }}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default ApplyModal;